module.exports = __webpack_public_path__ + "gr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gr.svg
// module id = 579
// module chunks = 0